import { Tabs as TabsComponent } from './Tabs'

export default TabsComponent
// eslint-disable-next-line import/export
export * from './Tabs'
